import React from "react";

export default function Terms() {
  return (
    <div className="w-full">
      {/* Hero Banner */}
      <div
        className="relative h-[300px] md:h-[400px] w-full bg-cover bg-center flex items-center justify-center"
        style={{
          backgroundImage:
            "url('/images/terms.webp')", // Add a banner image inside /public/images/
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <h1 className="relative text-4xl md:text-5xl font-bold text-white text-center">
          Terms
        </h1>
      </div>
    <div className="max-w-5xl mx-auto px-6 py-12 bg-white rounded-xl shadow-md">
      {/* Title */}
      <h1 className="text-4xl font-bold text-gray-900 mb-6">
        Terms & Conditions
      </h1>

      {/* Intro */}
      <p className="text-gray-700 leading-relaxed mb-6">
        These Terms & Conditions govern your use of the{" "}
        <strong>MAC LABS LIMITED</strong> website. By accessing or using the
        website, you agree to be bound by these terms.
      </p>

      {/* List of Terms */}
      <ol className="list-decimal ml-6 space-y-4 text-gray-700 leading-relaxed">
        <li>
          <strong className="text-gray-900">Acceptance of Terms:</strong> By
          using this site, you confirm that you are above 18 years of age and
          have the legal capacity to accept these Terms & Conditions.
        </li>

        <li>
          <strong className="text-gray-900">Use of Website:</strong> You agree
          to use this website only for lawful purposes. <br />
          – You must not attempt unauthorized access to our servers, data, or
          any restricted area of the site. <br />
          – Any misuse of the content or services provided may result in legal
          action.
        </li>

        <li>
          <strong className="text-gray-900">Intellectual Property:</strong> All
          content, including logos, trademarks, text, graphics, images, and
          product details, are the intellectual property of MAC LABS LIMITED
          unless stated otherwise. You may not copy, reproduce, distribute, or
          modify content without prior written consent.
        </li>

        <li>
          <strong className="text-gray-900">Products and Services:</strong> Any
          reference to our APIs, intermediates, or formulations is subject to
          local regulatory approval in the country of intended use. Information
          on the site should not be interpreted as a promotion or advertisement
          of products in regions where such promotion is not permitted by law.
        </li>

        <li>
          <strong className="text-gray-900">Confidentiality of Enquiries:</strong>{" "}
          Any business or product-related enquiry shared with us through the
          website shall be treated as confidential and handled in accordance
          with our{" "}
          <a href="/privacy" className="text-blue-600 hover:underline">
            Privacy Policy
          </a>
          .
        </li>

        <li>
          <strong className="text-gray-900">Limitation of Liability:</strong> We
          are not responsible for any damages or losses resulting from your use
          of this website or reliance on any information contained within.
        </li>

        <li>
          <strong className="text-gray-900">Indemnity:</strong> You agree to
          indemnify and hold harmless MAC LABS LIMITED, its employees, and
          affiliates from any claims, liabilities, losses, or expenses arising
          from your misuse of this website.
        </li>

        <li>
          <strong className="text-gray-900">Governing Law:</strong> These Terms
          & Conditions shall be governed by and construed in accordance with the
          laws of India. You agree that the courts located in Hyderabad,
          Telangana shall have exclusive jurisdiction over any disputes arising
          from or relating to your use of this website or our services.
        </li>

        <li>
          <strong className="text-gray-900">Amendments:</strong> We may revise
          these Terms & Conditions at any time without prior notice. Continued
          use of the website constitutes acceptance of the updated terms.
        </li>

        <li>
          <strong className="text-gray-900">Contact Information:</strong> For
          questions regarding these Terms & Conditions, please contact us at{" "}
          <a
            href="mailto:info@maclabsltd.com"
            className="text-blue-600 hover:underline"
          >
            info@maclabsltd.com
          </a>
          .
        </li>
      </ol>

      {/* Effective Date */}
      <p className="mt-6 text-gray-600 text-sm">
        <strong>Effective Date:</strong> 15-08-2025
      </p>
    </div>
    </div>
  );
}
